// extracted by mini-css-extract-plugin
export default {"myModal":"MyModel_myModal__sYcMD","active":"MyModel_active__5S5nO","myModalContent":"MyModel_myModalContent__bx0O+"};